import WhereDictionary from "../Utills/WhereDictionary";
import OrderService from "./OrderService";

export async function getAssignedOrders(afterResp) {
  await new Promise((res) => setTimeout(res, 300));
  const orderSer = new OrderService();
  orderSer.setControllerPath("http://localhost:3005/orders")
  orderSer.getAdminOrders((res)=>{
     const ordersColl = new WhereDictionary();
   
      res.ResultObject.forEach((order)=>{
        ordersColl.add(order.orderId,
          {
            orderId:order.orderId,
            orderNumber : order.orderNo,
            factoryId : order.factoryId,
            factoryName: order.factoryName,
            customerId:order.customerId,
            customerName: order.customerName,
            pickupLocation : order.pickupLocation,
            deliveryLocation:order.deliveryLocation,
            assignments :[]
          }
        );
      })

    orderSer.getAssignedTrucks((res)=>{
      res.ResultObject.forEach((assignment) =>{
        const order = ordersColl.get(assignment.orderId);
        order.assignments.push({
          assignmentId:assignment.assignmentId,
          truckId:assignment.truckId,
          truckNumber:assignment.truckNo,
          driverName:assignment.driverName,
          driverMobile:assignment.driverMobile,
          status:assignment.assignmentStatus,
        })
      })

      afterResp(ordersColl.getValuesAsArray());
    })
    
  });

 /* const orders = [
    // Factory 1 (3 orders)
    {
      orderId: '1',
      orderNumber: 'ORD-2023-001',
      factoryId: '1',
      factoryName: 'San Francisco Plant',
      customerId: '111',
      customerName: 'Tech Solutions Inc.',
      pickupLocation: [24.7136, 46.8258],
      deliveryLocation: [24.6629, 46.7728],
      assignments: [
        { assignmentId: 'A-1001', truckId: 'T-001', truckNumber: 'TRK-SF-001', driverName: 'John Doe', driverMobile: '+1 555-0001', status: 'Scheduled' },
        { assignmentId: 'A-1002', truckId: 'T-002', truckNumber: 'TRK-SF-002', driverName: 'Jane Smith', driverMobile: '+1 555-0002', status: 'In Transit' },
        { assignmentId: 'A-1003', truckId: 'T-003', truckNumber: 'TRK-SF-003', driverName: 'Adam Ray', driverMobile: '+1 555-0003', status: 'Delivered' },
        { assignmentId: 'A-1004', truckId: 'T-004', truckNumber: 'TRK-SF-004', driverName: 'Sara Lee', driverMobile: '+1 555-0004', status: 'In Transit' },
      ],
    },
    {
      orderId: '2',
      orderNumber: 'ORD-2023-002',
      factoryId: '1',
      factoryName: 'San Francisco Plant',
      customerId: '112',
      customerName: 'Global Innovations Ltd.',
      pickupLocation: [24.7196, 46.8268],
      deliveryLocation: [24.4629, 46.3728],
      assignments: [
        { assignmentId: 'A-1011', truckId: 'T-010', truckNumber: 'TRK-SF-010', driverName: 'Alice Johnson', driverMobile: '+1 555-0010', status: 'Delivered' },
      ],
    },
    {
      orderId: '3',
      orderNumber: 'ORD-2023-003',
      factoryId: '1',
      factoryName: 'San Francisco Plant',
      customerId: '113',
      customerName: 'Pioneer Industries',
      pickupLocation: [24.8136, 46.7258],
      deliveryLocation: [24.5629, 46.3728],
      assignments: [
        { assignmentId: 'A-1021', truckId: 'T-021', truckNumber: 'TRK-SF-021', driverName: 'Mike Johnson', driverMobile: '+1 555-0021', status: 'Scheduled' },
        { assignmentId: 'A-1022', truckId: 'T-022', truckNumber: 'TRK-SF-022', driverName: 'Bob Miles', driverMobile: '+1 555-0022', status: 'Scheduled' },
        { assignmentId: 'A-1023', truckId: 'T-023', truckNumber: 'TRK-SF-023', driverName: 'Kelly Chen', driverMobile: '+1 555-0023', status: 'Scheduled' },
        { assignmentId: 'A-1024', truckId: 'T-024', truckNumber: 'TRK-SF-024', driverName: 'Tom Hardy', driverMobile: '+1 555-0024', status: 'Scheduled' },
        { assignmentId: 'A-1025', truckId: 'T-025', truckNumber: 'TRK-SF-025', driverName: 'Ravi Patel', driverMobile: '+1 555-0025', status: 'Scheduled' },
      ],
    },

    // Factory 2 (5 orders)
    {
      orderId: '4',
      orderNumber: 'ORD-2023-004',
      factoryId: '2',
      factoryName: 'Oakland Depot',
      customerId: '114',
      customerName: 'BuildRight Co.',
      pickupLocation: [24.1136, 46.2258],
      deliveryLocation: [24.3629, 46.7728],
      assignments: [
        { assignmentId: 'A-2001', truckId: 'T-101', truckNumber: 'TRK-OK-101', driverName: 'Ivy Brooks', driverMobile: '+1 555-0101', status: 'In Transit' },
        { assignmentId: 'A-2002', truckId: 'T-102', truckNumber: 'TRK-OK-102', driverName: 'Sean Parker', driverMobile: '+1 555-0102', status: 'In Transit' },
      ],
    },
    {
      orderId: '5',
      orderNumber: 'ORD-2023-005',
      factoryId: '2',
      factoryName: 'Oakland Depot',
      customerId: '115',
      customerName: 'Metro Constructions',
      pickupLocation: [24.5236, 46.5358],
      deliveryLocation: [24.2629, 46.1728],
      assignments: [
        { assignmentId: 'A-2011', truckId: 'T-103', truckNumber: 'TRK-OK-103', driverName: 'Ava Li', driverMobile: '+1 555-0103', status: 'Delivered' },
      ],
    },
    {
      orderId: '6',
      orderNumber: 'ORD-2023-006',
      factoryId: '2',
      factoryName: 'Oakland Depot',
      customerId: '116',
      customerName: 'GreenStone LLC',
      pickupLocation: [24.6236, 46.6358],
      deliveryLocation: [24.1629, 46.0728],
      assignments: [
        { assignmentId: 'A-2021', truckId: 'T-104', truckNumber: 'TRK-OK-104', driverName: 'Leo Park', driverMobile: '+1 555-0104', status: 'Scheduled' },
        { assignmentId: 'A-2022', truckId: 'T-105', truckNumber: 'TRK-OK-105', driverName: 'Noah King', driverMobile: '+1 555-0105', status: 'Scheduled' },
        { assignmentId: 'A-2023', truckId: 'T-106', truckNumber: 'TRK-OK-106', driverName: 'Uma Rao', driverMobile: '+1 555-0106', status: 'Scheduled' },
      ],
    },
    {
      orderId: '7',
      orderNumber: 'ORD-2023-007',
      factoryId: '2',
      factoryName: 'Oakland Depot',
      customerId: '117',
      customerName: 'Skyline Builders',
      pickupLocation: [24.7236, 46.7358],
      deliveryLocation: [24.0629, 45.9728],
      assignments: [
        { assignmentId: 'A-2031', truckId: 'T-107', truckNumber: 'TRK-OK-107', driverName: 'Emma Rose', driverMobile: '+1 555-0107', status: 'In Transit' },
      ],
    },
    {
      orderId: '8',
      orderNumber: 'ORD-2023-008',
      factoryId: '2',
      factoryName: 'Oakland Depot',
      customerId: '118',
      customerName: 'Atlas Cement',
      pickupLocation: [24.8236, 46.8358],
      deliveryLocation: [23.9629, 45.8728],
      assignments: [
        { assignmentId: 'A-2041', truckId: 'T-108', truckNumber: 'TRK-OK-108', driverName: 'Sophia Kim', driverMobile: '+1 555-0108', status: 'Delivered' },
        { assignmentId: 'A-2042', truckId: 'T-109', truckNumber: 'TRK-OK-109', driverName: 'Ryan Chu', driverMobile: '+1 555-0109', status: 'Delivered' },
      ],
    },

    // Factory 3 (2 orders)
    {
      orderId: '9',
      orderNumber: 'ORD-2023-009',
      factoryId: '3',
      factoryName: 'Berkeley Plant',
      customerId: '119',
      customerName: 'Prime Concrete',
      pickupLocation: [24.3336, 46.1358],
      deliveryLocation: [24.2629, 46.8728],
      assignments: [
        { assignmentId: 'A-3001', truckId: 'T-201', truckNumber: 'TRK-BK-201', driverName: 'Olivia Frost', driverMobile: '+1 555-0201', status: 'In Transit' },
        { assignmentId: 'A-3002', truckId: 'T-202', truckNumber: 'TRK-BK-202', driverName: 'Mason Hunt', driverMobile: '+1 555-0202', status: 'In Transit' },
        { assignmentId: 'A-3003', truckId: 'T-203', truckNumber: 'TRK-BK-203', driverName: 'Ethan Cole', driverMobile: '+1 555-0203', status: 'In Transit' },
        { assignmentId: 'A-3004', truckId: 'T-204', truckNumber: 'TRK-BK-204', driverName: 'Lily Moore', driverMobile: '+1 555-0204', status: 'In Transit' },
      ],
    },
    {
      orderId: '10',
      orderNumber: 'ORD-2023-010',
      factoryId: '3',
      factoryName: 'Berkeley Plant',
      customerId: '120',
      customerName: 'Urban Mixers',
      pickupLocation: [24.4336, 46.2358],
      deliveryLocation: [24.1629, 46.9728],
      assignments: [
        { assignmentId: 'A-3011', truckId: 'T-205', truckNumber: 'TRK-BK-205', driverName: 'James Lee', driverMobile: '+1 555-0205', status: 'Scheduled' },
        { assignmentId: 'A-3012', truckId: 'T-206', truckNumber: 'TRK-BK-206', driverName: 'Grace Park', driverMobile: '+1 555-0206', status: 'Scheduled' },
      ],
    },
  ];*/

  
}